import { darken, lighten } from "polished";
import styled from "styled-components";

export const PlanoButtonContainer = styled.div`
  display: inline-block;
  width: 100%;
  margin: 10px;

  @media (min-width: 768px) {
    width: 350px;
  }
`;

export const PlanoButton = styled.div<any>`
  width: 100%;
  border: 1px solid #006789;
  border-radius: 5px;
  background: ${(props) =>
    props.ativo ? "#006789" : "#FFFFFF"};
  color: ${(props) => (props.ativo ? "#FFFFFF" : "#006789")};
  padding: 5px;
  text-align: center;
  transition: background 0.3s;

  &:hover {
    background: ${(props) =>
    props.ativo
      ? darken(0.1, "#006789")
      : lighten(0.4, "#FFFFFF")};
    cursor: pointer;
  }

  @media (min-width: 768px) {
    width: 350px;
  }
`;
